import { render, staticRenderFns } from "./MoralPersonCreate.vue?vue&type=template&id=36376622&scoped=true"
import script from "./MoralPersonCreate.vue?vue&type=script&lang=js"
export * from "./MoralPersonCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36376622",
  null
  
)

export default component.exports